import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  RiskExemptionParams,
  RiskExemptionResult,
  setRiskExemption,
} from "@/api/risk";
import { RiskQueryKeys } from "@/tanstackQuery/queries/risk";

export interface SetRiskExemptionOptions {
  onSuccess?: (data: RiskExemptionResult, variables: RiskExemptionParams) => void;
  onError?: (error: Error) => void;
}

// Dealer-only "Muafiyet": the switch follows the refetched row, no optimistic
// flip.
export const useSetRiskExemption = (options?: SetRiskExemptionOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: RiskExemptionParams) => setRiskExemption(params),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: [RiskQueryKeys.Matches] });
      options?.onSuccess?.(data, variables);
    },
    onError: options?.onError,
  });
};
